import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlatformConfigState } from '@core/models/platform-config.state';

import { mockResponse } from '../mock-response';
import { PlatformConfigRepository } from './platform-config.repository';
import { seedPlatformConfig } from './platform-config.seed';

/**
 * In-memory platform config. Unlike the entity repositories this is a single
 * immutable document rather than a `MockDataService` collection - nothing in
 * the storefront writes it, so there is no store to keep.
 */
@Injectable()
export class PlatformConfigMockRepository implements PlatformConfigRepository {
  private readonly config = seedPlatformConfig();

  get(): Observable<PlatformConfigState> {
    return mockResponse({
      ...this.config,
      bidIncrements: this.config.bidIncrements.map(band => ({ ...band })),
      localFindsRadiiMi: [...this.config.localFindsRadiiMi]
    });
  }
}
